import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_ds_get_plansService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { $top?: number, $skip?: number }): Promise<{ result?: { plan_id?: string, status?: boolean, name?: string, template_order_id?: number, template_order_lookup_code?: string, finished_product?: string, plan_setup?: string, plan_schedule?: string, next_execution?: string, last_run?: string, last_run_state?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_get_plans/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { $keys: string[] }): Promise<{ result?: { plan_id?: string, status?: boolean, name?: string, template_order_id?: number, template_order_lookup_code?: string, finished_product?: string, plan_setup?: string, plan_schedule?: string, next_execution?: string, last_run?: string, last_run_state?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_get_plans/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      }) {
      return false;
    }
}
